import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TableRowUnSelectEvent } from 'primeng/table';
import { Client } from 'src/app/core/entity/client';
import { Document, RenameDocument } from 'src/app/core/entity/document';

@Component({
  selector: 'app-file-browser-internal-section',
  templateUrl: './file-browser-internal-section.component.html',
})
export class FileBrowserInternalSectionComponent {
  @ViewChild('fileUpload', { static: true }) fileUpload!: ElementRef<HTMLInputElement>;

  @Input() client: Client | undefined;
  @Input() sendingFiles = false;
  @Input() currentPath = '/';
  @Input() columns: { field: string; header?: string; sortable?: boolean }[] = [];
  @Input() files: Document[] = [];
  @Input() loading = false;
  @Input() contextMenuItems: MenuItem[] = [];
  @Input() pendingDeletionDocument: Document = new Document();
  @Input() pendingRenameDocument: RenameDocument = new RenameDocument();
  @Input() selectedRow: Document | undefined;
  @Input() directory = '';
  @Input() displayDeleteFile = false;
  @Input() displayRenameDialog = false;

  @Output() loadFiles = new EventEmitter<void>();
  @Output() upDir = new EventEmitter<void>();
  @Output() uploadFiles = new EventEmitter<File[]>();
  @Output() selectedRowChange = new EventEmitter<Document | undefined>();
  @Output() directoryChange = new EventEmitter<string>();
  @Output() displayDeleteFileChange = new EventEmitter<boolean>();
  @Output() displayRenameDialogChange = new EventEmitter<boolean>();
  @Output() rowUnselect = new EventEmitter<TableRowUnSelectEvent>();
  @Output() rowDblClick = new EventEmitter<Document>();
  @Output() deleteFile = new EventEmitter<Document>();
  @Output() createDir = new EventEmitter<void>();
  @Output() afterDeleteDialog = new EventEmitter<boolean>();
  @Output() afterRenameDialog = new EventEmitter<boolean>();

  get selectedRowModel(): Document | undefined {
    return this.selectedRow;
  }

  set selectedRowModel(value: Document | undefined) {
    this.selectedRow = value;
    this.selectedRowChange.emit(value);
  }

  get directoryModel(): string {
    return this.directory;
  }

  set directoryModel(value: string) {
    this.directory = value;
    this.directoryChange.emit(value);
  }

  get displayDeleteFileModel(): boolean {
    return this.displayDeleteFile;
  }

  set displayDeleteFileModel(value: boolean) {
    this.displayDeleteFile = value;
    this.displayDeleteFileChange.emit(value);
  }

  get displayRenameDialogModel(): boolean {
    return this.displayRenameDialog;
  }

  set displayRenameDialogModel(value: boolean) {
    this.displayRenameDialog = value;
    this.displayRenameDialogChange.emit(value);
  }

  triggerFileUpload() {
    this.fileUpload.nativeElement.click();
  }

  onFileSelectionChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    if (files.length > 0) {
      this.uploadFiles.emit(files);
    }
    input.value = '';
  }
}
